/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://dgtaaoz3fvda7khpuj7i7h3ry4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-glf3twnn3zfk3npewamx5nx7fm",
    "aws_cognito_identity_pool_id": "us-west-2:03f4b04c-a802-41f8-a5fc-595b74d7b743",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_RfVTbl7sU",
    "aws_user_pools_web_client_id": "5e8g2mt8cnfq3o85hr8de9ot7c",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "public-website-storage-6af5fb3325137-staging",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
